import React from 'react'
import { ParticipantsList } from './list/page'

export const Ramadan2025ParticipantsPage = () => {
  return <ParticipantsList />
}
